import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk'; // Correct import for redux-thunk
import adminReducer from './admin/admin.reducer';
import coinHistoryReducer from './coinHistory/coinHistory.reducer';

const rootReducer = combineReducers({
  admin: adminReducer,
  coinHistory: coinHistoryReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;